/* eslint-disable no-restricted-syntax */
/* eslint-disable no-labels */

const validationName = (validationMessage, currentString) => {
  let isEqual;

  outerCycle: for (let i = 0; i < validationMessage.length; i += 1) {
    for (let j = 0; j < currentString.length; j += 1) {
      if (currentString[j] === validationMessage[i]) {
        isEqual = true;
        break outerCycle;
      } else {
        isEqual = false;
      }
    }
  }

  return !isEqual;
};

export default validationName;
